import { useEffect, useState } from "react";

const VISIT_COUNT_KEY = "siteVisitCount";
const SESSION_VISIT_KEY = "siteVisitCountedThisSession";
const INITIAL_VISIT_COUNT = 1221;

const VisitCounter = () => {
  const [visits, setVisits] = useState(0);

  useEffect(() => {
    try {
      const storedVisitValue = localStorage.getItem(VISIT_COUNT_KEY);
      const storedVisitNumber = Number(storedVisitValue) || 0;
      const storedVisits =
        storedVisitValue === null || storedVisitNumber < INITIAL_VISIT_COUNT
          ? INITIAL_VISIT_COUNT - 1
          : storedVisitNumber;
      const alreadyCounted = sessionStorage.getItem(SESSION_VISIT_KEY) === "true";

      if (alreadyCounted) {
        setVisits(storedVisits || INITIAL_VISIT_COUNT);
        return;
      }

      const nextVisits = storedVisits + 1;

      localStorage.setItem(VISIT_COUNT_KEY, String(nextVisits));
      sessionStorage.setItem(SESSION_VISIT_KEY, "true");
      setVisits(nextVisits);

      // TODO: Reemplazar luego por API backend:
      // GET /api/visitas
      // POST /api/visitas/incrementar
    } catch (error) {
      setVisits(0);
    }
  }, []);

  return (
    <p className="mb-0 text-body-secondary text-sm-end">
      Visitas al sitio: {visits}
    </p>
  );
};

export default VisitCounter;
